import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpResponse, HttpUtilService } from "../http-util.service";

@Injectable({
  providedIn: "root",
})
export class BookingBankReportService {
  constructor(private http: HttpUtilService) {}

  BookingBank(model: {
  }): Observable<HttpResponse<any>> {
    return this.http.post(
      `AutopacReportService.asmx/BookingBank`,
      {
        model: model,
      },
    );
  }
}
